import { Box, Text } from "rebass";
import { maxWidth } from "styled-system";
import styled from "styled-components";
import { LazyImage } from "../components/lazy-image";
import { WYSIWYG } from "../components/wysiwyg";

const Section = ({ image, title, body }) => {
  return (
    <Box py={[4, 4, 4, 6]} px={[3, 3, 3, 4]}>
      <Wrap mx="auto" maxWidth={1}>
        {image && (
          <ImageWrapper mx="auto">
            <S_LazyImage src={image.url} alt={image.alt} />
          </ImageWrapper>
        )}
        {title && (
          <Title
            maxWidth={0}
            mx="auto"
            lineHeight={1}
            textAlign="center"
            as="h2"
            fontFamily="semibold"
            letterSpacing={1}
            fontSize={[4, 4, 5, 6]}
          >
            {title}
          </Title>
        )}
        {body && (
          <Box mt={[4, 5, 6]}>
            <WYSIWYG content={body} />
          </Box>
        )}
      </Wrap>
    </Box>
  );
};

const Wrap = styled(Box)`
  ${maxWidth}
`;

const S_LazyImage = styled(LazyImage)`
  display: block;
`;

const Title = styled(Text)`
  ${maxWidth}
  text-transform: uppercase;
`;

const ImageWrapper = styled(Box)`
  max-width: 425px;
`;

export { Section };
